//**This is the SibsForever sidebar for the Diary

import isEmpty from 'lodash/isEmpty'
import React, { useState, useEffect } from 'react'
import usePagePerms from '../hooks/usePagePerms'
import { NavLink } from 'react-router-dom';
import { Menu } from 'react-bulma-components';
import { getHeaderText } from '../functions/location_fcns'
import { useSelector } from 'react-redux';
import AllSettings from '../common/AllSettings'
import PageHelp from '../common/help/PageHelp'
 
const helpHtml='<p><img src="https://sibsforever.org/img/journal/journal-side.png" alt="Journal TOC sidebar" width="189" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="148"></p><p><br></p><ul><li><span>Your journal entries are listed under the </span><strong>Table of Contents </strong>label&nbsp;(see below)</li><li>Select<strong> New Entry </strong>to<strong> create a new journal entry</strong>. Enter a title for the journal entry and&nbsp;a short summary on the <strong>New Entry popup form</strong>.</li></ul><p><br clear="all"><b>This is what a Journal Entry looks like in the Table of Contents</b>:</p><p><img src="https://sibsforever.org/img/journal/journal-toc-entry.png" alt="Journal TOC entry line" width="974" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="67"></p><p><img src="https://sibsforever.org/img/edit-icon.png" alt="edit icon" width="51" height="47" style="font-size: 1em; margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;"></p><p><br></p><p><span style="font-size: 1em; font-weight: 400;"><br></span></p><p><span style="font-size: 1em; font-weight: 400;"><br></span></p><p><span style="font-size: 1em; font-weight: 400;"><br></span></p><p><span style="font-weight: 400; font-size: 1em;"><span style="font-size: 1em;">Opens the</span><strong> journal entry for editing</strong><br clear="all"><span style="font-size: 1em;"><img src="https://sibsforever.org/img/delete-icon.png" alt="delete icon" width="48" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="41"></span></span></p><p><strong><br></strong></p><p><strong>Deletes the journal entry</strong><br clear="all"><img src="https://sibsforever.org/img/settings-icon.png" alt="Settings icon" width="47" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="46"></p><p>Opens <strong>settings popup for controlling who can view and comment</strong> on the journal entry.&nbsp; The<strong> lock icon&nbsp;</strong>(shown in the date column in the picture above) indicates that this entry has not been shared and remains private meaning only the author can view it.</p>'

const helpHeading = "Journal Table of Contents"

const DiarySidebar = ({isActive}) => {  

const styles = {
    hrStyle: { borderTop: "2px solid #bbb" },
    spanStyle: { marginRight: "2px", marginTop:"5px", marginBottom:"5px" }
}

   const [ canAdmin, canEdit, canView, isResolved ] = usePagePerms('diary', 'singleton')

   const [ editLinks, setEditLinks ] = useState("")
   const [ viewLinks, setViewLinks ] = useState("")
   const [ adminLinks, setAdminLinks ] = useState("")

   const [ isInit, setIsInit ] = useState(false)
   const user = useSelector(state => state.user);

   useEffect(() => {
      if (isResolved && !isEmpty(user) && !isEmpty(user.email))
      {
         if (canView) setViewLinks(
               <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/diary/view">
                <span className="nospace"><span className="menu-icon">
                 <i className="fa fa-eye"  style={styles.spanStyle}></i>
               </span>
               Preview</span>
               </NavLink></div>
             )
         if (canEdit) setEditLinks(
             <>
	         <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/diary/toc">
	         <span className="nospace"><span className="menu-icon">
	         <i className="fa fa-table"  style={styles.spanStyle}></i>
	         </span>
	           Table of Contents</span>
	         </NavLink></div>
	         <div><NavLink className="xmenu-block" activeClassName="is-active" to="/auth/diary/new">
             <span className="nospace"><span className="menu-icon">
             <i className="fa fa-plus"  style={styles.spanStyle}></i>
             </span>
             New Entry </span>
             </NavLink></div>
             </>
             )
         if (canAdmin) setAdminLinks(
             <>
             <hr className="is-hidden-mobile" style={styles.hrStyle} />
             <AllSettings pageType='diary' pageInstance='singleton' toLink='/auth/diary/settings'/>
             </>
             )

         setIsInit(true);
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ isResolved, canEdit, canAdmin, canView ])

    if (!isInit)
     return <div>Loading...</div>

    const help = canEdit?<PageHelp header={helpHeading} body={helpHtml}/>:""

    return (
  
  <Menu>
     <p className="menu-label is-hidden-mobile">{getHeaderText()}{help}</p>
        {editLinks}
<hr className="is-hidden-mobile" style={styles.hrStyle} />
        {viewLinks}
        {adminLinks}
  </Menu>
    )
  }

export default DiarySidebar

